export default "__VITE_ASSET__b3f20c83__"